import { observer } from 'mobx-react-lite';
import { isMobile } from 'react-device-detect';
import { useStores } from '../../stores';
import { PropsWithChildren } from '../props';
import DesktopDrawer from './DesktopDrawer';
import MobileDrawer from './MobileDrawer';

interface Props {}

const SideBarMenu = observer((props: PropsWithChildren<Props>) => {
    const { panelStore } = useStores();
    const open = !panelStore.sideBarCollapsed;

    if (isMobile) {
        return (
            <MobileDrawer open={open} onClose={() => panelStore.setCollapsed(true)}>
                {props.children}
            </MobileDrawer>
        );
    }

    return (
        <DesktopDrawer open={open}>
            {props.children}
        </DesktopDrawer>
    );
});

export default SideBarMenu;
